import { getBrandedTitle } from "../../helpers/BrandingHelper";
import { lazy, Suspense, useContext, useEffect, useMemo, useRef, useState } from "react";
import loaderContext from "../../context/loader/LoaderContext";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import userContext from "../../context/users/UserContext";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import toastContext from "../../context/toast/ToastContext";
import { initialize, purgeCache } from "./helpers/CornerstoneService";
import {
  activateMPRViewports,
  resizeViewport,
} from "./helpers/CornerstoneViewportService";
import CustomSpinner from "../../components/CustomSpinner";
import AlertSuccessModal from "../../components/AlertSuccessModal/AlertSuccessModal";
import ConfirmAlertModal from "../../components/ConfirmAlertModal/ConfirmAlertModal";
import CommunicationModal from "../Communication/CommunicationModal";
import TopBar from "./Components/TopBar";
import Annotations from "../Annotations/Annotations";
import ThumbnailList from "./Components/Thumbnail/ThumbnailList";
import NewReport from "../Report/NewReport";
import ViewportLayout from "./Components/Viewport/ViewportLayout";
import {
  CONSTRUCTABLE_MODALITIES,
  LATERAL_VIEW_MODALITY_LIST,
  USERTYPES,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  showPathologyForModalities,
} from "../../constants/Constants";
import { isMobile } from "react-device-detect";
import {
  useInRouterContext,
  useParams,
  useSearchParams,
} from "react-router-dom";
import themeContext from "../../context/theme/ThemeContext";
import ContextMenu from "./helpers/ContextMenu";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import Impression from "../../components/SVGComponents/Tools/Impression";
import NotAllowed from "../../components/NotAllowed";
import { userPreference } from "../../service/UserService";
import { use } from "i18next";
import RSNAModal from "../Report/components/ReportModals/RSNAModal/RSNAModal";
import SubmitTick from "./Components/SubmitTick/SubmitTick";
import AdvTopBar from "./Components/AdvTopBar";
import IframeViewer from "./Components/IframeViewer/IframeViewer";
import { getAdvViewerStatus } from "../../service/StudyViewerService";
import { t } from "i18next";
import ViewerStartToast from "../../components/Toast/ViewerStartToast";
import { PrimaryButton } from "@fluentui/react";
import { openInfinitViewer, opneWeasisViewer } from "../../helpers/CommonUtility";
import PatientDetails from "./Components/Overlays/PatientDetails";
import StudyDetails from "./Components/Overlays/StudyDetails";
import WeasisViewer from "./WeasisViewer";
import InfinitViewer from "./InfinitViewer";
const MobileReportOverlay = isMobile ? lazy(() => import("./Components/Overlays/MobileReportOverlay")) : null;
import MobileViewerContext from "../../context/studyviewer/MobileViewerContext";
import MobileHistoryBottomSheet from "./Components/AttachmentBox/MobileHistoryBottomSheet";
import AccountWarningModal from "../../components/AccountWarningModal";
import ReturnStudyModal from "./Components/ReturnStudyModal/ReturnStudyModal";
import LLMTopBar from "../Report/components/LLMReportHeader/LLMTopBar";
import ChatInput from "../Report/components/ChatInterface/ChatInput";
import InstructionStack from "../Report/components/ChatInterface/InstructionStack";
import AgenticReportingContext from "../../context/agentic-reporting/AgenticReportingContext";
import { isLLMAgentPresent } from "../../service/MaskImageService";

let inputRoutingResyncInFlight = false;

function resetKeyboardFocusToMainFrame(target) {
  if (inputRoutingResyncInFlight) {
    console.log("[input-resync] skipped — already in flight");
    return;
  }
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el || !document.body) {
    console.log("[input-resync] skipped — target or document.body not found", { target });
    return;
  }

  console.log("[input-resync] starting", new Date().toISOString());
  inputRoutingResyncInFlight = true;
  let done = false;

  const probe = document.createElement("iframe");
  probe.tabIndex = -1;
  probe.style.cssText =
    "position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;border:0;pointer-events:none;";

  const finish = () => {
    if (done) return;
    done = true;
    try { probe.remove(); } catch (_) {}
    inputRoutingResyncInFlight = false;
    console.log("[input-resync] finished", new Date().toISOString());
  };

  document.body.appendChild(probe);
  requestAnimationFrame(() => {
    try {
      probe.focus();
      console.log("[input-resync] probe focused");
    } catch (_) {}
    requestAnimationFrame(() => {
      try {
        el.focus({ preventScroll: true });
        console.log("[input-resync] target refocused", el);
      } catch (_) {}
      setTimeout(finish, 0);
      setTimeout(finish, 1000);
    });
  });
}
const AdvanceViewer = (props) => {
  const { slideReportOpen, setSlideReportOpen, showHistory } = useContext(MobileViewerContext);
  var gf_location = "";
  const [cornerstoneInitialized, setCornerstoneInitialized] = useState(false);
  const [showPathologyOptions, setShowPathologyOptions] = useState(
    isMobile ? false : true
  );
  const [pathologyOptionOpened, setPathologyOptionOpened] = useState(true);
  const [advViewerAvailable, setAdvViewerAvailable] = useState(false);
  const [documentTitle, setDocumentTitle] = useState(null);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight * 0.88);

  const [startTouchX, setStartTouchX] = useState(0);
  const [endTouchX, setEndTouchX] = useState(0);
  const [isAdvFullscreen, setIsAdvFullscreen] = useState(false);
  const advViewerFullscreenRef = useRef(null);
  const reportMenuBeforeFullscreenRef = useRef(null);

  const { studyId } = useParams();
  const effectRan = useRef(false);
  const [searchParams] = useSearchParams();
  // const firmId = searchParams.get("firmId");
  // const studyId = searchParams.get("studyId");
  // const studyId = window.location.search.substring(
  //   window.location.search.indexOf("=") + 1,
  //   window.location.search.length
  // )

  const { theme,themeName } = useContext(themeContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const {
    assignmentData,
    setConfirmAlertModal,
    qcData,
    fetchStudyData,
    generateStudytData,
    studyData,
    studyResponseData,
    studyModality,
    showToast,
    savedKeyImages,
    keyImages,
    setStudyData,
    progress,
    dataGathered,
    setDataGathered,
    thumbnailLoaded,
    setThumbnailLoaded,
    setMessageCount,
    messageCount,
    fetchPriorStudyData,
    fetchPriorStudyReportsOnly,
    priorStudyData,
    patientStudyData,
    impressions,
    isAccessAllowed,
    notAllowedMessage,
    setEnableHeatmap,
    setEnableOutline,
    firmViewerId,
    setFirmViewerId,
    viewportLoading,
    meddreamFullUrl,
    setMeddreamFullUrl,
    advanceViewerURLIndex,
    advanceViewerSlotUUID,
    releaseAdvanceViewerSlot,
    extReportRecieved,
    parentChildReportsObj,
    showStartAlertToast,
    showStudyExpirationPopup,
    showStudyAlreadyExpiredPopup, 
    weasisViewerUser,
    weasisPatientDetails,
    infinitViewerUser,
    infinitViewerUrl,
    accessionNumber,
    reportMenu,
    seriesMenu,
    setReportMenu,
    setSeriesMenu,
    showAccountWarning,
    setShowAccountWarning,
    accountWarningText,
    showAiResult,
    showSavedReport,
    keyImagePresent,
    isPriorsStudy,
  } = useContext(studyviewerContext);
  const { authenticated, loadByUsername, roles, username, privilegedFirmDoctor, enableLlmReport } =
    useContext(userContext);
  const {
    hideCommnunicationModal,
    showCommunicationModal,
    setShowCommunicationModal,
    lockStudy,
    checkIfCancelOrNot,
    getData,
    alertSuccessModal,
    setAlertSuccessModal,
    confirmAlertModal,
    hideAlertSuccessModal,
    isClientReportExist,
    openRSNAModal,
    RSNAModalContent,
    setOpenRSNAModal,
    regenerateClick,
    showSubmitTick,
    studyParentId,
    setIsAdvanceViewer,
    modality,
    studyDescription,
    setKeyImagePresentStudyList,
    showReturnStudyModal,
    setShowReturnStudyModal,
  } = useContext(studyReportContext);

  // Bridge the authoritative backend key-image flag from the viewer context
  // into StudyReportState (same value the study list pushes), so the report
  // editor's download/preview menus highlight consistently.
  useEffect(() => {
    setKeyImagePresentStudyList(keyImagePresent === true);
  }, [keyImagePresent]);

  const {
    annotationData,
    activeViewportIndex,
    annotationDataAI,
    allTextToolAnnotation,
    changeLayout,
    viewportLoadingState,
    mprViewportElement,
    setMprViewportElements,
    isMPRActive,
    contextMenuOpen,
    isCompareActive,
    showImpressions,
    allowAddingTextAnnotation,
  } = useContext(ViewportContext);

  const { showToastv2, showProgressToast, setProgressList, progressList } =
    useContext(toastContext);

  const { activeModality,activeThumbnailIndex, activeStudyId, setActiveStudyId } = useContext(ThumbnailContext);

  const { isAgenticTab, userPrompts, isInstructionCollapsed, setIsInstructionCollapsed } =
    useContext(AgenticReportingContext);

  // const [seriesMenu, setSeriesMenu] = useState(true);
  // const [reportMenu, setReportMenu] = useState(false);


  // --- Priors: keep the report panel on whatever study the viewer is showing -------------
  //
  // In the basic viewer activeStudyId moves when a thumbnail is clicked. Here MedDream owns
  // the thumbnails and the viewports, so the id arrives over its postMessage integration
  // channel instead (see helpers/MedDreamIntegration). Everything downstream is the code the
  // basic viewer already uses: NewReport turns activeStudyId != studyParentId into
  // isChildStudyReportState, which swaps in the prior's report and hides Save / Submit /
  // Preview / Download / QC / Mark as Suspect and the annotation controls.
  //
  // Only the reports are fetched, not the full prior study data -- MedDream renders the
  // images, so Cornerstone stacks and thumbnails would be built and never used.
  const priorReportsRequestedRef = useRef(false);
  useEffect(() => {
    if (!isPriorsStudy || priorReportsRequestedRef.current) return;
    if (!studyId || firmViewerId == -1 || firmViewerId == null) return;
    priorReportsRequestedRef.current = true;
    fetchPriorStudyReportsOnly(studyId);
  }, [isPriorsStudy, studyId, firmViewerId]);

  // MedDream reports the study behind a viewport by whatever identifier the token used.
  // V1 tokens use the numeric study id (resolved without this map); V2/key-image tokens
  // address the reported study by its StudyInstanceUID, which only this map can turn back
  // into an Augmento study id.
  const studyInstanceUidMap = useMemo(() => {
    const map = {};
    Object.keys(parentChildReportsObj || {}).forEach((id) => {
      const uid = parentChildReportsObj[id]?.studyInstanceUId;
      if (uid) map[uid] = parseInt(id, 10);
    });
    return map;
  }, [parentChildReportsObj]);

  // Two reasons to withhold the id from the report panel. activeStudyId starts as "" and
  // NewReport reads anything that is neither null nor equal to studyParentId as "a prior is
  // open" -- which would disable every action button before the viewer has said anything.
  // And until the prior reports have arrived there is nothing for handleUpdateReportSection
  // to swap in, so an early id would blank the report while disabling the buttons.
  const priorReportsLoaded = Object.keys(parentChildReportsObj || {}).length > 0;
  const reportActiveStudyId =
    !priorReportsLoaded || activeStudyId === "" || activeStudyId == null
      ? null
      : activeStudyId;

  useEffect(() => {
    setFirmViewerId(searchParams.get("firmId"));
  }, []);

  useEffect(() => {
    // console.log("FIRM ID: " + firmId);
  }, [firmViewerId]);

  useEffect(() => {
    // console.log("--- Message Count ---- " + messageCount);
    if (messageCount > 0) {
      //setShowCommunicationModal(true);
    }
  }, [messageCount]);

  useEffect(() => {
  const maybeResync = (e) => {
    if (!e.target.closest(".fr-element")) return;
    console.log(`[input-resync] triggered by "${e.type}"`, e.target);
    resetKeyboardFocusToMainFrame(".fr-element");
  };
  document.addEventListener("focusin", maybeResync);
  document.addEventListener("paste", maybeResync, true);
  return () => {
    document.removeEventListener("focusin", maybeResync);
    document.removeEventListener("paste", maybeResync, true);
    };
  }, []);

  const checkForAdvViewerStatus = async () => {
        const res = await getAdvViewerStatus();
        if(res.data.result == "SUCCESS"){
        // if(true){
            setAdvViewerAvailable(true);
            setLoaderRunning(true);
            ref.current.continuousStart();
            const res = await fetchStudyData(studyId,false);
            if(res){
                setLoaderRunning(false);
                ref.current.complete();
            }
        }else{
            setAlertSuccessModal(()=>{
                const newItem = {...alertSuccessModal};
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = t("string-literals.adv-viewer-not-available");
                return newItem;
              });
              setAdvViewerAvailable(false);
              getData(false);
        }
  }

  useEffect(()=>{

    if (!authenticated) {
        loadByUsername();
    }
    if (firmViewerId != -1) {
        setIsAdvanceViewer(true);
        checkForAdvViewerStatus();
      }
   
  },[firmViewerId])

  const restoreReportMenuState = () => {
    if (reportMenuBeforeFullscreenRef.current !== null) {
      setReportMenu(reportMenuBeforeFullscreenRef.current);
      reportMenuBeforeFullscreenRef.current = null;
    }
  };

  const toggleAdvFullscreen = () => {
    const el = advViewerFullscreenRef.current;
    if (!el) return;
    if (!document.fullscreenElement) {
      reportMenuBeforeFullscreenRef.current = reportMenu;
      el.requestFullscreen()
        .then(() => {
          setIsAdvFullscreen(true);
          setReportMenu(false);
        })
        .catch(() => {
          reportMenuBeforeFullscreenRef.current = null;
        });
    } else {
      document
        .exitFullscreen()
        .then(() => {
          setIsAdvFullscreen(false);
          restoreReportMenuState();
        })
        .catch(() => {});
    }
  };

  useEffect(() => {
    const onFullscreenChange = () => {
      const isNowFullscreen = !!document.fullscreenElement;
      setIsAdvFullscreen(isNowFullscreen);
      if (!isNowFullscreen) {
        restoreReportMenuState();
      }
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  // useEffect(() => {
  //   if (
  //     CONSTRUCTABLE_MODALITIES.includes(activeModality) &&
  //     cornerstoneInitialized &&
  //     thumbnailLoaded &&
  //     !isMPRViewportInitialized
  //   ) {
  //     activateMPRViewports(setMprViewportElements);
  //     setIsMPRViewportInitialized(true);
  //   }
  // }, [activeModality, cornerstoneInitialized, thumbnailLoaded]);

  const getStudyData = async () => {
    if (advViewerAvailable) {
        console.log("--- Running")
      
    }
  };

  useEffect(() => {
    if (!isAccessAllowed) {
      ref.current.complete();
    }
  }, [isAccessAllowed]);

//   const getPriorStudyData = async () => {
//     if (!dataGathered) {
//       setLoaderRunning(true);
//       ref.current.continuousStart();
//       await fetchPriorStudyData(studyId);
//     }
//   };

  const callAPIs = async () => {
    if (!authenticated) {
      await loadByUsername();
    }
    // if (!cornerstoneInitialized) {
    //   initializeCornerstone();
    // }
    if (props.priors) {
      //getPriorStudyData();
    } else {
      getStudyData();
    }
  };

//   const getUserPreferenceData = async () => {
//     const response = await userPreference();
//     if (response.status === 200) {
//       if (
//         studyData.heatmapStacks[activeThumbnailIndex].imageIds[0] !== null &&
//         studyData.heatmapStacks[activeThumbnailIndex].imageIds[0] !== ""
//       ) {
//         setIsHeatMapEnabled(response.data.data.userPreference.heatMap);
//       }
//       if (
//         studyData.outlineStacks[activeThumbnailIndex].imageIds[0] !== null &&
//         studyData.outlineStacks[activeThumbnailIndex].imageIds[0] !== ""
//       ) {
//         // setIsHeatMapEnabled(response.data.data.userPreference.heatMap);
//         setIsOutlineEnabled(response.data.data.userPreference.outline);
//       }
//     }
//   };

//   useEffect(() => {
//     console.log(allowAddingTextAnnotation);
//     if (
//       thumbnailLoaded &&
//       allowAddingTextAnnotation &&
//       SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(studyModality)
//     ) {
//       setTimeout(() => {
//         getUserPreferenceData();
//       }, 1500);
//     }
//   }, [thumbnailLoaded, allowAddingTextAnnotation]);

// VAPT: the slot is a Web Lock now (see StudyViewerState getSlotAdvanceViewerUrl). The browser
// frees it when the tab really closes, so nothing is released here any more - which also means
// clicking "Stay" on the leave-site prompt no longer gives the slot away while the study is
// still open. The prompt itself is unchanged.
useEffect(() => {
  // Leaving the advanced viewer inside the same tab (no page unload) - free the slot.
  return () => releaseAdvanceViewerSlot();
}, []);

useEffect(() => {
  const handleBeforeUnload = (e) => {
    // Uncomment the next line to trigger a confirmation dialog
    // e.preventDefault();
    // OLD: onCloseAdvanceViewer(advanceViewerURLIndex,advanceViewerSlotUUID); // Call your cleanup function

    // The next line is needed to show a confirmation dialog
    e.returnValue = ""; // This triggers the confirmation dialog in most browsers
  };

  window.addEventListener("beforeunload", handleBeforeUnload);
  window.addEventListener('unload', handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
    window.removeEventListener('unload', handleBeforeUnload);
  };
});

// OLD (released the slot from the localStorage list; replaced by the Web Lock above):
// const onCloseAdvanceViewer = (advanceViewerURLIndex, UUID) => {
//   if (advanceViewerURLIndex !== -1) {
//     let advViewerSlots = JSON.parse(localStorage.getItem("advViewerSlots")) || Array(10).fill({ available: 0, uuid: null });
//
//     // Check if the UUID matches the slot's UUID before updating
//     if (advViewerSlots[advanceViewerURLIndex]?.uuid === UUID) {
//       advViewerSlots[advanceViewerURLIndex] = { available: 0, uuid: null }; // Mark as available and clear the UUID
//       localStorage.setItem("advViewerSlots", JSON.stringify(advViewerSlots));
//       console.log(`Slot ${advanceViewerURLIndex} released.`);
//     } else {
//       console.error(`UUID mismatch or invalid slot. Slot ${advanceViewerURLIndex} not updated.`);
//     }
//   } else {
//     console.error("Invalid advanceViewerURLIndex.");
//   }
// };


  useEffect(() => {
    if (
      roles.length != 0 && dataGathered &&
      isClientReportExist != null
    ) {
      if (!roles[0].includes(USERTYPES.FIRMDOCTOR) || showSavedReport) {

        console.log("--- Running getData -----",studyParentId);
        getData(false);
      }
    }
  }, [roles, studyParentId, dataGathered, isClientReportExist]);

  useEffect(() => {
    // if (!authenticated) {
    //   loadByUsername();
    // }
    // if(!cornerstoneInitialized) {
    //   initializeCornerstone();
    // }
    // if (props.priors) {
    //   getPriorStudyData();
    // } else {
    //   getStudyData();
    // }
    if (firmViewerId != -1 && advViewerAvailable) {
      callAPIs();
    }
  }, [firmViewerId]);

  useEffect(() => {
    if (
      typeof patientStudyData?.patientName !== "undefined" &&
      patientStudyData?.patientName !== null
    )
      setDocumentTitle(getBrandedTitle(patientStudyData?.patientName));
  }, [patientStudyData]);

  useEffect(() => {
    if (documentTitle !== null) {
      document.title = documentTitle;
    }
  }, [documentTitle]);

//   useEffect(() => {
//     // console.log(modality);
//     if (LATERAL_VIEW_MODALITY_LIST.includes(studyModality) && !isMobile) {
//       changeLayout(1, 2);
//     }
//   }, [studyModality]);

  const openReportMenu = () => {
    setTimeout(() => {
      setReportMenu((prevFlag) => !prevFlag);
      setSeriesMenu(false);
    }, 100);
    setTimeout(() => {
      resizeViewport();
    }, 500);
  };

  const openSeriesMenu = () => {
    setTimeout(() => {
      setReportMenu(false);
    }, 100);
  };

  const onKeyPress = (event) => {
  //  const keyCode = event.which;
  const { target, keyCode } = event;
   if(target.nodeName!=='INPUT' && target.nodeName!=='TEXTAREA' && target.nodeName!='SELECT' && !target.isContentEditable )
   {
    switch (keyCode) {
      case 83:
          openSeriesMenu();
        break;
      case 82:
        if((!roles[0].includes(USERTYPES.FIRMDOCTOR) || showSavedReport) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN)) 
          openReportMenu();
        break;
      default:
        break;
    }
   }
   
  };

  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);
    return () => {
      window.removeEventListener("keydown", onKeyPress);
    };
  });
  // Bug fix (advanced viewer): viewport/report sections shifting left 
  const reportMenuRef = useRef(reportMenu);
  reportMenuRef.current = reportMenu;
  const initialViewerFocusedRef = useRef(false);
  useEffect(() => {
    const viewerReady = meddreamFullUrl || weasisViewerUser || infinitViewerUser;
    if (isMobile || !viewerReady) return;
    if (initialViewerFocusedRef.current) return;
    initialViewerFocusedRef.current = true;

    const focusEmbeddedViewer = () => {
      if (reportMenuRef.current) return;
      const iframeEl = document.querySelector(
        "#viewport-div .main-container iframe"
      );
      if (iframeEl) {
        iframeEl.focus({ preventScroll: true });
      }
    };
    focusEmbeddedViewer();
    const timer = setTimeout(focusEmbeddedViewer, 1100);
    return () => clearTimeout(timer);
  }, [meddreamFullUrl, weasisViewerUser, infinitViewerUser, isMobile]);

  // const handleTouchStart = (event) => {
  //   setStartTouchX(event.changedTouches[0].screenX);
  // };

  // const handleTouchEnd = (event) => {
  //   setEndTouchX(event.changedTouches[0].screenX);
  // };

  // useEffect(() => {
  //   if (startTouchX > endTouchX) {
  //     setSeriesMenu(false);
  //   }
  //   if (startTouchX < endTouchX) {
  //     setSeriesMenu(true);
  //   }
  // }, [endTouchX]);

  const regenerateRSNA = (reportName) => {
    hideModal();
    if (reportName == "TUBERCULOSIS") {
      regenerateClick();
    }
  };

  const hideModal = () => {
    // console.log("hiding");
    setOpenRSNAModal(false);
  };

  useEffect(() =>{
    console.log('weasis viewer', weasisViewerUser)
    console.log('infinit Viewer', infinitViewerUser)
    if(weasisViewerUser){
      openReportMenu();
      opneWeasisViewer(studyId);
    }
    if(infinitViewerUser){
      console.log('infinit Viewer URL', infinitViewerUrl);
      openReportMenu();
      openInfinitViewer(accessionNumber,infinitViewerUrl);
    }
  }, [studyId,accessionNumber,infinitViewerUrl, weasisViewerUser , infinitViewerUser]);


  return (
    <>
      {/* <ProgressToast/> */}
      {/* {showToast.show && (
        <Toast state={showToast.state} text={showToast.message} />
      )} */}
      {/* {showToast.loading && <CustomSpinner />} */}
      {/* {loadingState || loadSpinnerToastState.loading ? ( */}
      {!isAccessAllowed && notAllowedMessage !== "" ? (
        <NotAllowed msg={notAllowedMessage} />
      ) : (
        <>
          {
            ((!props.priors && studyData.stacks.length !== 0) || true) && (
              <>
                {openRSNAModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      zIndex: 100000,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <RSNAModal
                      regenerateClick={regenerateRSNA}
                      hideModal={hideModal}
                      content={RSNAModalContent}
                      isModalOpen={openRSNAModal}
                    />
                  </div>
                )}
                {alertSuccessModal?.show && (
                  <AlertSuccessModal
                    isError={alertSuccessModal.isError}
                    isWarning={alertSuccessModal.isWarning}
                    isSuccess={alertSuccessModal.isSuccess}
                    heading={alertSuccessModal.heading}
                    description={alertSuccessModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={alertSuccessModal?.show}
                  />
                )}
                {confirmAlertModal?.show && (
                  <ConfirmAlertModal
                    isError={confirmAlertModal.isError}
                    heading={confirmAlertModal.heading}
                    isConflictPopup={confirmAlertModal.isConflictPopup}
                    description={confirmAlertModal.description}
                    hideModal={hideAlertSuccessModal}
                    isModalOpen={confirmAlertModal?.show}
                    type={confirmAlertModal.type}
                    lockStudy={lockStudy}
                    assignmentData={assignmentData}
                    checkIfCancelOrNot={checkIfCancelOrNot}
                    annotationData={[]}
                    annotationDataAI={[]}
                    keyImages={keyImages}
                    activeViewportIndex={0}
                    setConfirmAlertModal={setConfirmAlertModal}
                    allTextToolAnnotation={allTextToolAnnotation}
                    qcData={qcData}
                  />
                )}
                <AccountWarningModal
                  showModal={showAccountWarning}
                  hideModal={() => setShowAccountWarning(false)}
                  warningText={accountWarningText}
                />
                {showSubmitTick && <SubmitTick />}
                {showCommunicationModal && (
                  <CommunicationModal
                    isModalOpen={showCommunicationModal}
                    hideModal={hideCommnunicationModal}
                    studyParentId={studyParentId}
                    activeStudyId={activeStudyId}
                    child={false}
                    setMessageCount={setMessageCount}
                    studylist={false}
                  />
                )}
                {/* mount the Return Study modal on the mobile advance
                    viewer so the top-bar lock/return icon works (desktop advance
                    viewer already gets it via the report panel / NewReport). */}
                {isMobile && showReturnStudyModal && (
                  <ReturnStudyModal
                    setShowReturnStudyModal={setShowReturnStudyModal}
                    showReturnStudyModal={showReturnStudyModal}
                  />
                )}
                {/* <button onClick={toast}>toast</button> */}
                <div
                  ref={advViewerFullscreenRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    minHeight: "100vh",
                    background: "var(--background-theme-color)",
                  }}
                >
                <AdvTopBar
                  showPathologyOptions={false}
                  setShowPathologyOptions={setShowPathologyOptions}
                  openReport={openReportMenu}
                  openSeries={openSeriesMenu}
                  seriesMenu={seriesMenu}
                  assignmentData={assignmentData}
                  priors={props.priors}
                  onToggleFullscreen={toggleAdvFullscreen}
                  isAdvFullscreen={isAdvFullscreen}
                />
                {isMobile ? (
                  <Suspense fallback={null}>
                  {/* ── Mobile layout ── */}
                  <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    {/* Viewport + report overlay in relative container */}
                    <div style={{ flex: 1, minHeight: 0, position: "relative", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                      <div id="viewport-div" style={{ flex: 1, minHeight: 0 }}>
                        <div
                          className="viewer-thumbnail-section"
                          style={{ height: `${showPathologyOptions ? "92%" : "100%"}` }}
                        >
                          <div
                            className="viewer-viewport-container"
                            style={{
                              opacity: `${seriesMenu ? "0.5" : "1"}`,
                              width: "calc(100vw - 200px)",
                            }}
                          >
                            <div className="viewer-viewport-section h100">
                              <div className="main-container h100 w100">
                                <div
                                  style={{ width: "99.9%", margin: "0px 0.25%", height: "99.5%", position: "relative" }}
                                  className={`${weasisViewerUser || infinitViewerUser ? (themeName === "light" ? "weasis-viewer-container weasis-light" : "weasis-viewer-container") : ""}`}
                                >
                                  {!(weasisViewerUser || infinitViewerUser) && <IframeViewer
                                    meddreamFullUrl={meddreamFullUrl}
                                    studyInstanceUidMap={studyInstanceUidMap}
                                    onActiveStudyChange={setActiveStudyId}
                                  />}
                                  {weasisViewerUser && <WeasisViewer weasisPatientDetails={weasisPatientDetails} studyId={studyId} />}
                                  {infinitViewerUser && !weasisViewerUser && <InfinitViewer weasisPatientDetails={weasisPatientDetails} infinitViewerUrl={infinitViewerUrl} accessionNumber={accessionNumber} />}
                                </div>
                              </div>
                              {showStartAlertToast && <ViewerStartToast />}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Report overlay slides over viewport */}
                      <div className={`viewer-right ${slideReportOpen ? "viewer-open" : ""}`}>
                        <MobileReportOverlay
                          isOpen={slideReportOpen}
                          onClose={() => setSlideReportOpen(false)}
                          readOnly={false}
                          modality={studyModality}
                          patientId={patientStudyData?.patientId || "UNKNOWN"}
                          parentChildReportsObj={parentChildReportsObj}
                          activeStudyId={reportActiveStudyId}
                          studyParentId={studyParentId}
                          extReportRecieved={extReportRecieved}
                          showStudyExpirationPopup={showStudyExpirationPopup}
                          showStudyAlreadyExpiredPopup={showStudyAlreadyExpiredPopup}
                        />
                      </div>
                    </div>
                    {/* Tab strip — visible to all except Firm Doctor and Firm Technician */}
                    {roles.length > 0 && !roles[0].includes(USERTYPES.FIRMDOCTOR) && !roles[0].includes(USERTYPES.FIRMTECHNICIAN) && (
                      <LLMTopBar />
                    )}
                    {/* ChatInput + InstructionStack */}
                    {roles.length > 0 && roles[0].includes(USERTYPES.RADIOLOGIST) && isAgenticTab && enableLlmReport && isLLMAgentPresent(studyModality, studyDescription) && (
                      <div
                        className="viewer-chat-input-section"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: isInstructionCollapsed ? "auto" : "128px",
                          backgroundColor: "#d9d9d9",
                          borderTop: "1px solid #ccc",
                          borderBottom: "1px solid #ccc",
                          padding: "0 5px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div style={{ flexShrink: 0 }}>
                          <ChatInput onSend={() => setSlideReportOpen(true)} />
                        </div>
                        <div
                          style={{
                            flex: isInstructionCollapsed ? "none" : 1,
                            overflow: "auto",
                            marginTop: isInstructionCollapsed ? "0" : "4px",
                          }}
                        >
                          <InstructionStack
                            instructions={userPrompts}
                            isCollapsed={isInstructionCollapsed}
                            onToggle={() => setIsInstructionCollapsed(!isInstructionCollapsed)}
                          />
                        </div>
                      </div>
                    )}
                    {/* History & attachments bottom sheet — the mobile advance
                        viewer top bar opens this, same as the basic viewer. */}
                    <div className={`popup ${showHistory ? "viewer-open" : ""}`}>
                      <MobileHistoryBottomSheet />
                    </div>
                  </div>
                  </Suspense>
                ) : (
                  /* ── Desktop layout ── */
                  <div
                    id="viewport-div"
                    style={{ height: "96%", flex: 1, minHeight: 0 }}
                  >
                    <div
                      className="viewer-thumbnail-section"
                      style={{ height: `${showPathologyOptions ? "92%" : "100%"}` }}
                    >
                      <div
                        className="viewer-viewport-container"
                        style={{
                          opacity: "1",
                          width: "calc(100vw - 150px)",
                        }}
                      >
                        <div className="viewer-viewport-section h100">
                          <div className="main-container h100 w100">
                            <div
                              style={{ width: "99.5%", margin: "0px 0.25%", height: "99.5%", position: "relative" }}
                              className={`${weasisViewerUser || infinitViewerUser ? (themeName === "light" ? "weasis-viewer-container weasis-light" : "weasis-viewer-container") : ""}`}
                            >
                              {!(weasisViewerUser || infinitViewerUser) && <IframeViewer
                                    meddreamFullUrl={meddreamFullUrl}
                                    studyInstanceUidMap={studyInstanceUidMap}
                                    onActiveStudyChange={setActiveStudyId}
                                  />}
                              {weasisViewerUser && <WeasisViewer weasisPatientDetails={weasisPatientDetails} studyId={studyId} />}
                              {infinitViewerUser && !weasisViewerUser && <InfinitViewer weasisPatientDetails={weasisPatientDetails} infinitViewerUrl={infinitViewerUrl} accessionNumber={accessionNumber} />}
                            </div>
                          </div>
                          {showStartAlertToast && <ViewerStartToast />}
                          <div
                            className={
                              `sidebarMenu sidebar-right modal-scroll` +
                              (reportMenu === true ? " sidebar-open" : "")
                            }
                          >
                            <NewReport
                              modality={modality}
                              showPathologyOptions={showPathologyOptions}
                              customHeight={windowHeight}
                              qcData={qcData}
                              keyImages={keyImages}
                              annotationData={[]}
                              activeViewportIndex={0}
                              assignmentData={[]}
                              annotationDataAI={[]}
                              allTextToolAnnotation={allTextToolAnnotation}
                              reportMenu={reportMenu}
                              patientName={patientStudyData?.patientName}
                              patientId={patientStudyData?.patientId}
                              isStudyList={false}
                              parentChildReportsObj={parentChildReportsObj}
                              activeStudyId={reportActiveStudyId}
                              studyParentId={studyParentId}
                              extReportReived ={extReportRecieved}
                              showStudyExpirationPopup={showStudyExpirationPopup}
                              showStudyAlreadyExpiredPopup={showStudyAlreadyExpiredPopup}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                </div>
              </>
            )}
        </>
      )}
    </>
  );
};

export default AdvanceViewer;
